<template>
  <div>
    <span @click="display=true">
      <slot></slot>
    </span>
    <modal v-if="display" :title="resource.instruction || 'New Resource'" btn="Save" @submit="save" @close="cancel">
        <h-input type="text" label="Instructions" v-model="resource.instruction" outline/>
        <h-select :items="typeSelections" v-if="!resource.id" outline label="Select type of resource" v-model="resourceType" ></h-select>
        <h-input 
          type="text"
          v-if="resource.url || resourceType==URL_TYPE" 
          v-model="resource.url" 
          label="Full Url" 
          placeholder="https://youtube.com" />
        <div v-if="resource.file || resourceType==FILE_TYPE" >
          <label v-if="resource.file">Current File: {{resource.file}}</label>
          <input type="file" ref="fileUpload" />
        </div>
        <v-alert :value="displayError" type="error">{{displayError}}</v-alert>
    </modal>
  </div>
</template>

<script>
const FILE_TYPE = "File to Download";
const URL_TYPE = "URL Link";
import modal from "@/components/modal/default";
import axios from "axios";
import snackbar from "@/services/hubs/snackbar";

export default {
  props: ["resource"],
  components: {
    modal
  },
  data() {
    return {
      display: false,
      resourceType: "",
      typeSelections: [FILE_TYPE, URL_TYPE],
      FILE_TYPE,
      URL_TYPE,
      instruction: {},
      saving: false,
      displayError: ""
    };
  },
  created() {
    this._initResource = Object.assign({}, this.resource);
  },
  methods: {
    cancel() {
      this.display = false;
      Object.assign(this.resource, this._initResource);
    },
    save() {
      this.displayError = "";
      let endpoint = `${
        process.env.VUE_APP_API_URL
      }coaches/exercise-resources/`;
      let method = "post";
      if (this.resource.id) {
        method = "patch";
        endpoint = `${endpoint}${this.resource.id}/`;
      }
      let formData = new FormData();
      formData.append("instruction", this.resource.instruction);
      formData.append("url", this.resource.url);
      formData.append("exercise", this.resource.exercise);
      if (!this.resource.instruction) {
        this.displayError = "No instructions given";
        return;
      }
      const file = this.$refs.fileUpload && this.$refs.fileUpload.files[0];
      if (!file && this.resourceType == this.FILE_TYPE) {
        this.displayError = "No file uploaded";
        return;
      }

      if (!this.resource.url && !file) {
        this.displayError = "No resources given";
        return;
      }

      if (file) {
        const name = file.name;
        formData.append("file", file, name);
      }
      snackbar.update("Saving");
      this.saving = true;
      axios[method](endpoint, formData).then(r => {
        this.$emit("saved", r.data);
        snackbar.update("Saved");
        this.saving = false;
        this.display = false;
      });
    }
  }
};
</script>
